export default __webpack_public_path__ + "static/media/958.34b9e41b.png";